export default __webpack_public_path__ + "img/046ca6af6ea6f616dc4951e3936b8b4c.png";